<div class="container">
  <mic-breadcrumb id="finished-product-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/setup/siteSetup" label="{{ translationService.translate('siteSetupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }} Details"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title m-0 mt-3" id="casing-size-heading">{{ translationService.translate('siteSetupText') }}</h2>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm" class="filters flex flex-row justify-center items-start sm-flex-col gap-4 site-setup-filters">
      <div class="grid-container">
        <mat-form-field subscriptSizing="dynamic" class="filter-field">
          <mat-label>{{ translationService.translate('codeText') }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ translationService.translate('searchByText') + ' ' + translationService.translate('codeText') }}"
            formControlName="code"
          />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic" class="filter-field">
          <mat-label>{{ translationService.translate('nameText') }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ translationService.translate('searchByText') + ' ' + translationService.translate('nameText') }}"
            formControlName="name"
          />
        </mat-form-field>
        <app-spec-dropdown
          [id]="'statusId'"
          [options]="statusOptions"
          [formGroup]="filterForm"
          [controlName]="'status'"
          [label]="translationService.translate('statusColumnText')"
          [editMode]="true"
          [placeholder]="'Select ' + translationService.translate('statusColumnText')"
        ></app-spec-dropdown>
      </div>
      <div class="flex flex-row flex-1 gap-4 justify-end site-setup-actions">
        <button
          id="reset-filters"
          type="button"
          mat-flat-button
          color="accent"
          (click)="clearFilters()"
          class="mic-btn-icon-left btn-clear"
        >
          <mat-icon>refresh</mat-icon>
          {{ translationService.translate('clearSelectionText') }}
        </button>
        <button
          id="add-button"
          type="button"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left btn-primary"
          (click)="createSite()"
          [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
        >
          <mat-icon>add</mat-icon> {{ translationService.translate('addText') }}
        </button>
      </div>
    </form>
  </mat-card>

  <div id="finished-product-table" class="cam-table mt-2">
    <div class="table-inner">
      <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button><mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}</button>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'statusCell'">
          <div class="flex flex-row gap-1">
            @if (item.status === 'Y') {
            <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
            } @if (item.status === 'N') {
            <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
            }
          </div>
        </ng-container>
      </mic-table>
    </div>
  </div>
</div>
